import React from 'react';

export default () => (
  <div className="rank-group">
    <div className="rank-header">RANK -</div>
    <div className="rank-txt">SUPERSTAR</div>
  </div>
);
